// src/services/processContinueService.js

import { API_BASE_URL } from "../config/api";

let _token = null;
export function setToken(token) { _token = token; }

export async function continueProcess(accesskey, payload) {
  const url = new URL(`/process/continue/${accesskey}`, API_BASE_URL);

  const response = await fetch(url.toString(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(_token ? { Authorization: `Bearer ${_token}` } : {}),
    },
    body: JSON.stringify(payload),
  });

  const text = await response.text();

  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error("Resposta inválida do servidor");
  }

  const result = { ...data, httpStatus: response.status, ok: response.ok };

  if (result.httpStatus === 423) {
    console.warn(`Bloqueado por: ${result.locked_by}`);
  }

  return result;
}